function PortalController(){
	this.className	= "PortalController";
	this.glob		= ["/hub**"];
	this.debug		= false;
};
PortalController.inheritsFrom( StandardController );
PortalController.prototype.swap = function() {
	this.$body = $("body").find(".js-body");
	this.$page = this.$body.find(".js-page");
	this.$widgetList = this.$page.find(".js-widget-list");
	this.$widgetItem = this.$widgetList.find(".js-widget-list--item");

	let accreditationController = Aviator.get("accreditationController");
	accreditationController.setup();
	accreditationController.checkAccreditation();

	// Link up entire item.
	this.$widgetItem.on('click touchstart', function(e) {
		window.location.href = $(this).find('a').attr('href');
	});

	/*
	this.$widgetItem.on('click touchstart', (e) => {
		const $this = $(e.currentTarget);
		const $content = $this.find('.js-widget-list--content');
		const contentHeight = $content[0].scrollHeight === $content[0].clientHeight ? 0 : $content[0].scrollHeight;
		$content.stop().animate({height: contentHeight});
		$this.toggleClass('widget-list--open');
	});
	*/

	/*
	this.$widgetItem.on('mouseenter', (e) => {
		const $this = $(e.currentTarget);
		const $content = $this.find('.js-widget-list--content');
		const contentHeight = $content[0].scrollHeight;
		$content.stop().animate({height: contentHeight});
		$this.toggleClass('widget-list--open');
	}).on('mouseleave', (e) => {
		const $this = $(e.currentTarget);
		const $content = $this.find('.js-widget-list--content');
		$content.stop().animate({height: 0});
		$this.toggleClass('widget-list--open');
	});
	*/
}